<template>
  <full-width-sidebar-left
      sub-menu-selector="organizingpanel"
  >
    <div slot="mainContent">
      <h1>
        <icon class="mr-2" size="0.9" type="tag"/>
        {{ $t('Tags') }}
      </h1>
      <organization-switcher
          v-if="initDone"
          :pre-set-organization-id="organizationId"
          :show-all-orgs="true"
          :show-teams="false"
          :exclude-organizations="excludeOrganizations"
          @setOrganization="setOrganization"
      />
      <tag-input
          v-if="organizationId"
          :can-set-color="true"
          :limit-tags-to-organizations="[organizationId]"
          :creation-organization-id="organizationId"
          :show-tag-list-permanently="true"
          :table-mode="true"
          :tags-are-deletable="true"
          class="mt-3"
      />
    </div>
  </full-width-sidebar-left>
</template>

<script>
import FullWidthSidebarLeft from "../layouts/FullWidthSidebarLeft";
import TagInput from "../components/forms/TagInput";
import OrganizationSwitcher from "../components/organizations/OrganizationSwitcher";
import Icon from "../components/Icon";

export default {
  name: 'TagsEdit',
  components: {
    FullWidthSidebarLeft,
    OrganizationSwitcher,
    TagInput,
    Icon,
  },
  data() {
    return {
      id: '',
      organizationId: null,
      excludeOrganizations: [],
      initDone: false
    };
  },
  // todo: check all organzations the user belongs to and whether the user has the permission to create ON the orgnization, then limit the organization switcher to those
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.initDone = false;
      const orgs = this.$store.getters.getCurrentUserOrgs;
      for(const org of orgs) {
        if (!await this.checkOrgPermission(org.id)) {
          this.excludeOrganizations.push(org.id);
        } else if(!this.organizationId) {
          this.setOrganization(org.id);
        }
      }
      this.initDone = true;
    },
    setOrganization(id) {
      this.organizationId = id;
    },
    async checkOrgPermission(organizationId) {
      return await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'writeTags',
        opOnly: true,
        orgPermissionOnly: true,
        organizationId: organizationId
      });
    }
  }
}
</script>
